type PriceShape = {
  price?: string | number | null;
  discountedPrice?: string | number | null;
  kg?: string | number | null;
} | null | undefined;

type PriceFlavor = {
  pricePerKg?: string | number | null;
} | null | undefined;

type PriceTopping = {
  code?: string | null;
  price?: string | number | null;
  discountedPrice?: string | number | null;
} | null | undefined;

const pickPrice = (
  price?: string | number | null,
  discountedPrice?: string | number | null
) => {
  const discounted = Number(discountedPrice) || 0;
  if (discounted > 0) return discounted;
  return Number(price) || 0;
};

/** Same formula as order custom cake: shape + (flavor pricePerKg × shape kg) + topping */
export const calculateCakeUnitPrice = (
  shape?: PriceShape,
  flavor?: PriceFlavor,
  topping?: PriceTopping,
  options?: { printingCharges?: number; customImagePrice?: number }
): number => {
  if (!shape || !flavor) return 0;

  const shapePrice = pickPrice(shape.price, shape.discountedPrice);
  const flavorPrice =
    (Number(flavor.pricePerKg) || 0) * (Number(shape.kg) || 0);

  let toppingPrice = 0;
  if (topping && topping.code !== 'without') {
    toppingPrice = pickPrice(topping.price, topping.discountedPrice);
  }

  const printingCharges = options?.printingCharges || 0;
  const customImagePrice = options?.customImagePrice || 0;

  return Number(
    (shapePrice + flavorPrice + toppingPrice + printingCharges + customImagePrice).toFixed(2)
  );
};
